<div id="bot-details" [formGroup]="form">
  <table class="table-striped table-td-border-right table-no-border-bottom">
    <tr class="bot-config-container">
      <td id="kyloe-call-email-container">
        <div style="display: flex; gap: 16px;">
          <div style="flex: 1;">
            <mat-label>Email origin domains</mat-label>
            <div formArrayName="domains">
              @for (domain of domainsArray.controls; track $index) {
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
                  <input
                    matTooltip="All emails sent to {{inviteAddress}} from this domain will be associated with your corporation."
                    class="destination-input-field"
                    type="text"
                    [formControlName]="$index"
                    placeholder="Everything after @ e.g. yourcompany.com"
                    style="flex: 1;">
                  @if ($index > 0) {
                    <button
                      mat-icon-button
                      type="button"
                      (click)="removeDomain($index)"
                      matTooltip="Remove domain"
                      style="flex-shrink: 0;">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
            <button
              theme="small"
              type="button"
              class="no-squish"
              (click)="addDomain()"
              style="margin-top: 4px;">
              Add domain
              <mat-icon iconPositionEnd>add</mat-icon>
            </button>
          </div>
          <div style="flex: 1;" id="bot-name">
            <mat-label>Bot name</mat-label>
            <input class="destination-input-field" type="text" formControlName="botName" placeholder="e.g. Meeting NoteTaker">
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
